<template>
  <div v-if="isExpired" class="news-promo-tag">Акция завершена</div>
</template>

<script>
export default {
  name: "NewsPromoTag",
  props: {
    promoEnd: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentDate: null,
    };
  },
  mounted() {
    this.currentDate = new Date();
  },
  computed: {
    isExpired() {
      if (!this.promoEnd || !this.currentDate) return false;
      const promoDate = new Date(Date.parse(this.promoEnd.replace(" ", "T")));
      return promoDate < this.currentDate;
    },
  },
};
</script>

<style lang="scss" scoped>
.news-promo-tag {
  padding: 5px 8px;
  width: fit-content;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  background-color: #c45e45;
  border-radius: 2px;
  text-wrap: nowrap;
}
</style>
